// Product Types
export const CONFIGURABLE_BLINDS = 'CONFIGURABLE_BLINDS';
export const CUSTOM_COUNTERTOPS = 'custom-countertops';